"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getXsrfToken = exports.getCookieFromDocument = exports.ResponseCookie = void 0;
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const helpers_1 = require("./helpers");
const Journey_1 = require("./Journey");
const enhancedFetch_1 = require("./enhancedFetch");
const EnhancedFetchError_1 = require("./EnhancedFetchError");
class ResponseCookie {
    constructor(response) {
        this.response = response;
    }
    getRawCookieHeaders() {
        var _a;
        const raw = (_a = this.response.headers.raw()['set-cookie']) !== null && _a !== void 0 ? _a : [];
        const cookieStrs = raw.map((entry) => {
            const parts = entry.split(';');
            const cookiePart = parts[0];
            return cookiePart;
        });
        return cookieStrs;
    }
    getCookieHeaderString() {
        return this.getRawCookieHeaders()
            .join(';');
    }
    getCookie(cname, decode) {
        if (!helpers_1.isServer()) {
            const name = `${cname}=`;
            const decodedCookie = decodeURIComponent(document.cookie);
            const ca = decodedCookie.split(';');
            // eslint-disable-next-line no-plusplus,no-restricted-syntax
            for (let c of ca) {
                while (c.charAt(0) === ' ') {
                    c = c.slice(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.slice(name.length, c.length);
                }
            }
            return '';
        }
        return decode ? decodeURIComponent(this.toArray()[cname]) : this.toArray()[cname];
    }
    toArray() {
        const cookieStrs = this.getRawCookieHeaders();
        const cookie = {};
        cookieStrs.forEach((cookieStr) => {
            const equalSides = cookieStr.split('=');
            const name = equalSides[0];
            const value = equalSides[1];
            cookie[name] = value;
        });
        return cookie;
    }
}
exports.ResponseCookie = ResponseCookie;
function getCookieFromDocument(name) {
    var _a;
    if (helpers_1.isServer()) {
        return;
    }
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2)
        return (_a = parts.pop()) === null || _a === void 0 ? void 0 : _a.split(';').shift();
}
exports.getCookieFromDocument = getCookieFromDocument;
function fetchXsrfToken() {
    return __awaiter(this, void 0, void 0, function* () {
        const csrfResponse = yield cross_fetch_1.default(enhancedFetch_1.isomorphicUrl(Journey_1.Journey.config.csrfCookieUrl), {
            credentials: 'include',
        });
        if (!csrfResponse.ok) {
            const errorMessage = yield EnhancedFetchError_1.createErrorMessageOfResponse(csrfResponse);
            throw new Error(errorMessage);
        }
        return (new ResponseCookie(csrfResponse)).getCookie('XSRF-TOKEN', true);
    });
}
const getXsrfTokenCbs = [];
function getXsrfToken() {
    return new Promise((resolve, reject) => {
        // only will be provided in clientside
        const storedXsrfCookie = getCookieFromDocument('XSRF-TOKEN');
        // if we already have a xsrf token, dont request out
        // as simply using the xsrf token in the future request will return us a new one.
        if (storedXsrfCookie) {
            resolve(decodeURIComponent(storedXsrfCookie));
            return;
        }
        if (getXsrfTokenCbs.length > 0) {
            getXsrfTokenCbs.push({ resolve, reject });
            return;
        }
        getXsrfTokenCbs.push({ resolve, reject });
        fetchXsrfToken().then((xsrfToken) => {
            getXsrfTokenCbs.forEach((cb) => cb.resolve(xsrfToken));
        }).catch((error) => {
            getXsrfTokenCbs.forEach((cb) => cb.reject(error));
        });
    });
}
exports.getXsrfToken = getXsrfToken;
